import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
export var SwapPageDaySelectorHeader = function (_a) {
    var swapFromDay = _a.swapFromDay;
    var t = useTranslation().t;
    return (React.createElement(View, { dataTestId: "SwapPageDaySelectorHeader", padding: { top: 'S300', left: 'S300', right: 'S300' } },
        React.createElement(Text, { color: "neutral90", fontWeight: 'bold', role: "heading", "aria-level": 1 }, t('shift_management_features_SwapPageHeader_text_1')),
        React.createElement(Text, { color: "neutral90" },
            t('shift_management_features_SwapPageHeader_text_2'),
            ' ',
            React.createElement("strong", null, "".concat(swapFromDay.weekdayShort, " ").concat(swapFromDay.monthShort, " ").concat(swapFromDay.day)))));
};
